import { ItineraryPointVersion as ServerItineraryPointVersion } from 'server/models/ItineraryPointVersion';
import { ItineraryPointVersionExtraDataData } from './ItineraryPointVersionExtraData';
import { parseIfNonNull } from './ExtraDataUtils';

export { ItineraryPointVersionData, ItineraryPointVersionOptions } from 'server/models/ItineraryPointVersion';

export class ItineraryPointVersion extends ServerItineraryPointVersion {
    ExtraData() {
        return parseIfNonNull<ItineraryPointVersionExtraDataData>(this.ExtraDataJSON());
    }
}



// WEBPACK FOOTER //
// ./data/models/ItineraryPointVersion.ts